export default __webpack_public_path__ + "static/media/img-0397-serbia-half-face.adc1df30.png";